import React, { useState, useEffect } from 'react';
import useVetrina from '../../hooks/useVetrina';
import useMediaQuery from '../../hooks/useMediaQuery';
import CustomTable from '../../components/CustomTable/CustomTable';
import LoadingTable from '../../components/LoadingTable/LoadingTable';
import useVetrinaCorsiConfigTable from '../../configTable/useVetrinaCorsiConfigTable';
import PromoManagerModal from '../../components/PromoManagerModal/PromoManagerModal';
import { ACTION_TYPES } from '../../model/actions';
// Aggiungeremo la modale per le promozioni in un secondo momento
// import PromoManagerModal from '../../components/PromoManagerModal/PromoManagerModal';

const VetrinaCorsiPage = () => {
    const isWideScreen = useMediaQuery('(min-width: 1200px)');
    const { isLoading, getVetrina } = useVetrina();

    const [vetrina, setVetrina] = useState([]);
    const [selectedCorso, setSelectedCorso] = useState(null);
    const [showPromoModal, setShowPromoModal] = useState(false);

    const vetrinaConfigTable = useVetrinaCorsiConfigTable();

    /*
    useEffect(() => {
        const fetchVetrina = async () => {
            const data = await getVetrina();
            setVetrina(data);
        };
        fetchVetrina();
    }, []);
    */

    const fetchVetrina = async () => {
        const data = await getVetrina();
        setVetrina(data);
    };

    useEffect(() => {
        fetchVetrina();
    }, []);


    const openPromoModal = (corso) => {
        setSelectedCorso(corso);
        setShowPromoModal(true);
    };

    const actions = [
        {
            icon: 'bi-tags-fill text-primary',
            label: 'Promozioni',
            tooltip: 'Gestisci Promozioni',
            type: ACTION_TYPES.CONFIG,
            onClick: (item) => openPromoModal(item)
        }
    ];

return (
        <>
            <div className={`card custom-card w-100 shadow ${isWideScreen ? 'p-5' : 'px-1 py-3'}`}>
                <div className="container">
                    <div className="d-flex justify-content-between custom-card-header">
                        <div className="d-flex gap-3 custom-card-title my-2">
                            <div className="custom-icon-container">
                                <i className="bi custom-icon bi-shop-window fs-2"></i>
                            </div>
                            <div className="align-self-center">
                                <span className="fs-4 d-block"><i><b>Vetrina Corsi</b></i></span>
                            </div>
                        </div>
                    </div>
                    
                    <div className="mt-4">
                        {isLoading ? <LoadingTable loadingCol={5} /> :
                            <CustomTable
                                data={vetrina}
                                columns={vetrinaConfigTable}
                                actions={actions}
                                actionsLabel="Promozioni"
                            />
                        }
                    </div>
                </div>
            </div>

            {/* --- BLOCCO CORRETTO E FUNZIONANTE --- */}
            {showPromoModal && (
                <PromoManagerModal
                    show={showPromoModal}
                    onHide={() => setShowPromoModal(false)}
                    corsoVetrina={selectedCorso}
                    onUpdate={fetchVetrina}
                />
            )}
        </>
    );
};

export default VetrinaCorsiPage;